import { useFormik } from 'formik'
import React from 'react'
import { Button, Form, FormControl } from 'react-bootstrap'
import * as Yup from "yup"

const Inputs = () => {

  const initialValues = {
    email:""
  }

  const validationSchema = Yup.object({
    email:Yup
        .string()
        .email("Please provide a valid email address")
        .required("Email address is required")
  })

  const onSubmit = (values) => { 
    console.log(values);
   }

   const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  })


  

  return (
   
      <Form noValidate onSubmit={formik.handleSubmit} className='d-flex align-items-center   justify-content-center gap-3 mb-5'>
        <FormControl
          type='email'
          placeholder='Your email adress...'
          className='input-box'
          {...formik.getFieldProps("email")}
          isInvalid={formik.touched.email && formik.errors.email} 
          />
        <Form.Control.Feedback type='inValid' className='feedback'>
          {formik.errors.email}
          </ Form.Control.Feedback>
        <Button type='submit' id='submit'>Notify Me</Button>
      </Form>

  )
}

export default Inputs
